import "./singleBookPending.scss";
import Sidebar from "../../components/sidebar/Sidebar";
import { useEffect } from "react";
import Single from "../single/Single";
import { useParams } from "react-router-dom";

const SingleBookPending = () => {
  const { productId } = useParams();
  useEffect(() => {
    document.title = "Wishallbook";
  }, []);

  return (
    <div className="list">
      <Sidebar />
      <div className="listContainer">
        <Single type="pending" bookID={productId} />
      </div>
    </div>
  );
};

export default SingleBookPending;
